/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FormsAndPrecedentsService {
    /**
     * List all forms and precedents
     * Get a paginated list of forms and precedents
     * @param search Search by name, keywords, or description
     * @param perPage Items per page
     * @returns any List of forms and precedents
     * @throws ApiError
     */
    public static cb51Be626D280480Caf0Fe63F5F85302(
        search?: string,
        perPage: number = 15,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/forms-and-precedents',
            query: {
                'search': search,
                'per_page': perPage,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create a new form or precedent
     * Create a new form or precedent
     * @param requestBody
     * @returns any Form or precedent created successfully
     * @throws ApiError
     */
    public static dca7Fc122768D2E333Aa05F588E4485(
        requestBody: {
            name?: string;
            document_name?: string;
            keywords?: string;
            description?: string;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/forms-and-precedents',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get a specific form or precedent
     * Retrieve details of a specific form or precedent
     * @param id Form or precedent ID
     * @returns any Form or precedent details
     * @throws ApiError
     */
    public static a36A7C68770F44Bd64C801Ed16712(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/forms-and-precedents/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Form or precedent not found`,
            },
        });
    }
    /**
     * Update a form or precedent
     * Update an existing form or precedent
     * @param id Form or precedent ID
     * @param requestBody
     * @returns any Form or precedent updated successfully
     * @throws ApiError
     */
    public static d470A2583F555Cffba24F0101444C45(
        id: number,
        requestBody: {
            name?: string;
            document_name?: string;
            keywords?: string;
            description?: string;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/forms-and-precedents/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `Form or precedent not found`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Delete a form or precedent
     * Delete an existing form or precedent
     * @param id Form or precedent ID
     * @returns any Form or precedent deleted successfully
     * @throws ApiError
     */
    public static af20Fd97D11Eb5891A536523F6724(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/forms-and-precedents/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Form or precedent not found`,
            },
        });
    }
}
